
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import RecommendedForYou from '@/components/RecommendedForYou';
import Footer from '@/components/Footer';
import { SEOEnhanced } from '@/components/SEOEnhanced';
import { seoKeywords } from '@/utils/seoEnhanced';

const Index = () => {
  console.log('🦎 Safari Index component rendering...');
  
  // Safe context usage with error handling
  let user = null;
  let language = 'en';
  
  try {
    const authContext = useAuth();
    user = authContext.user;
    console.log('🦎 Safari Auth context loaded successfully');
  } catch (error) {
    console.error('🚨 Safari Auth context error:', error);
  }
  
  try {
    const languageContext = useLanguage();
    language = languageContext.language;
    console.log('🦎 Safari Language context loaded successfully:', language);
  } catch (error) {
    console.error('🚨 Safari Language context error:', error);
    language = 'en'; // Fallback to English
  }

  try {
    console.log('🦎 Safari Index: Rendering components...');
    
    return (
      <div className="min-h-screen">
        <SEOEnhanced
          title={language === 'ar' 
            ? 'مسكن - سكن طلابي موثوق في مصر | ابحث عن سكنك المثالي'
            : 'Maskan - Trusted Student Housing in Egypt | Find Your Perfect Accommodation'
          }
          description={language === 'ar'
            ? 'ابحث عن سكن طلابي متحقق بالقرب من الجامعات المصرية. مسكن يوفر خيارات سكن آمنة وبأسعار معقولة للطلاب مع قوائم متحققة 100% واستجابة سريعة.'
            : 'Find verified student housing near Egyptian universities. Maskan offers safe, affordable accommodation options for students with 100% verified listings and quick responses.'
          }
          keywords={seoKeywords.homepage}
          canonical="/"
          structuredDataType="Organization"
          lang={language}
          breadcrumbs={[
            { name: language === 'ar' ? 'الرئيسية' : 'Home', url: 'https://maskan-student-nest.lovable.app/' }
          ]}
          faqs={[
            {
              question: language === 'ar' ? 'ما هو مسكن؟' : 'What is Maskan?',
              answer: language === 'ar' 
                ? 'مسكن هو منصة إسكان طلابي موثوقة في مصر تربط الطلاب بسكن متحقق بالقرب من الجامعات'
                : 'Maskan is a trusted student housing platform in Egypt connecting students with verified accommodation near universities'
            },
            {
              question: language === 'ar' ? 'هل القوائم متحققة؟' : 'Are listings verified?',
              answer: language === 'ar'
                ? 'نعم، جميع قوائمنا متحققة 100% لضمان سلامة وجودة السكن'
                : 'Yes, all our listings are 100% verified to ensure safety and quality of accommodation'
            }
          ]}
        />
        
        <Header />
        <main>
          <HeroSection currentLang={language} />
          <RecommendedForYou />
        </main>
        <Footer />
      </div>
    );
  } catch (error) {
    console.error('🚨 Safari Index component error:', error);
    
    // Fallback UI for Safari
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Welcome to Maskan</h1>
          <p className="text-muted-foreground">Loading...</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 bg-primary text-primary-foreground px-4 py-2 rounded"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
};

export default Index;
